import { z } from 'zod'
import { salesCommonSchema } from './sales-common'

/** 營業人員 Schema */
export const salesSchema = salesCommonSchema.merge(
  z.object({
    /** 是否有效 */
    enable: z.boolean()
  })
)

/** 營業人員 */
export interface Sales extends z.infer<typeof salesSchema> {}
